<template>
    <main role="main" class="container">
        <h1 class="text-center">Latest Runs</h1>
        <notices :errors="errors" :notices="notices"></notices>
        <cards @error="onError"></cards>
    </main>
</template>

<script>
import Notices from '../components/Notices.vue';
import Cards from '../components/Cards.vue';
import CommonMixin from '../util/common';

export default {
    components: { Notices, Cards },
    mixins: [CommonMixin],
    data() {
        return {}
    },
    methods: {},
    mounted() {
    }
}
</script>